import { lazyOverlay } from '@/routing/lazyRoute';

/** T-0559: the new-page dialog, its own chunk: it is mounted only once somebody asks for a page. */
export const NewDashboardPageDialog = lazyOverlay(
  () => import('./NewDashboardPageDialog'),
  (module) => module.NewDashboardPageDialog,
);
